import { __extends } from "tslib";
import * as React from 'react';
import { MultiSelect } from '../../../primitives/selectors';
import { DeprecatedText } from '../../../deprecated-typography';
import { namespacedClassnames } from '../../../common';
import { renderFlatCatName, categoryOptionRenderer } from '../common';
var MultiCategorySelector = /** @class */ (function (_super) {
    __extends(MultiCategorySelector, _super);
    function MultiCategorySelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (vals) {
            var valsIds = vals.map(function (i) { return i.value; });
            var selectedCats = _this.props.categories.filter(function (i) { return valsIds.indexOf(i.id) > -1; });
            _this.props.onChange(selectedCats);
        };
        return _this;
    }
    MultiCategorySelector.prototype.render = function () {
        var props = this.props;
        var options = props.categories.map(function (i) { return renderFlatCatName(i); });
        var selectedVals = props.value.map(function (i) { return renderFlatCatName(i); });
        var classes = namespacedClassnames('multi-category-selector', { 'with-error': !!props.errorMsg });
        return (React.createElement("div", { className: classes },
            React.createElement(MultiSelect, { value: selectedVals, options: options, onChange: this.onChange, placeholder: props.placeholder, optionRenderer: categoryOptionRenderer, valueRenderer: categoryOptionRenderer, disabled: props.disabled || false }),
            props.errorMsg ? React.createElement(DeprecatedText, { type: 't4a', className: 'validation-error' }, props.errorMsg) : null));
    };
    return MultiCategorySelector;
}(React.PureComponent));
export { MultiCategorySelector };
//# sourceMappingURL=multi-category-selector.comp.js.map